(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name managePairing.directive:searchPanelManagePairing
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="managePairing">
     <file name="index.html">
     <search-panel-manage-pairing></search-panel-manage-pairing>
     </file>
     </example>
     *
     */
    angular
        .module('managePairing')
        .directive('searchPanelManagePairing', searchPanelManagePairing)
    	.directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	});

    function searchPanelManagePairing(CommonMasterData, MessageService, $stateParams, EventManagerService, applicationConstants) {
        return {
            restrict: 'EA',
            scope: {
                baseList: '=',
                airCraftTypes: '=',
                airportList: '=',
                pairingValidity:'=',
                modifyFlags: '=',
                commonCriteriaList : '=',
                acmiTypesList : '=',
                onSubmitAction: '&',
                searchCriteria: '='
            },
            templateUrl: 'manage-pairing/directives/search-panel-manage-pairing-directive.tpl.html',
            replace: false,
            bindToController: true,
            controllerAs: 'searchPanelManagePairing',
            controller: function () {
                var vm = this;
                vm.name = 'searchPanelManagePairing';
                vm.model = {
                    showSearchPanel: false,
                    searchParams: setSearchParamChanges(vm.searchCriteria)
                };
                //Events
                EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VIEW_MODE_CHANGE, searchProceed);

                vm.model.searchParams.fromDate = moment().format("DD/MM/YYYY");
                vm.model.searchParams.toDate = moment().format("DD/MM/YYYY");

                vm.changeDate = function(flg){
                    searchPairingNameList(flg);
                };

                vm.onSearchPanelClick = function (event) {
                    vm.model.showSearchPanel = !vm.model.showSearchPanel;
                    if (vm.model.showSearchPanel &&
                        (vm.model.searchParams.fromDate!=="" && vm.model.searchParams.toDate!=="")){
                        searchPairingNameList('toDate');
                    }
                };

                if($stateParams.patternId == null){
                	vm.onSearchPanelClick();
                }

                vm.onClickSearch = function(){
                    var sendMode = {
                        mode:'D',
                        flag:'new'
                    };
                    searchProceed(sendMode);
                };

                vm.onChangeModifiedFlight = function(){

                };

                vm.onChangeModifiedPairing = function(){

                };

                function searchPairingNameList(flg) {
                    var obj={};
                    if (flg.toUpperCase()==='FROMDATE'){
                        vm.model.searchParams.toDate = vm.model.searchParams.fromDate;
                    }
                    obj.fromDate = vm.model.searchParams.fromDate;
                    obj.toDate= vm.model.searchParams.toDate;
                    vm.pairings = [];
                    CommonMasterData.getPairingNames(obj, function(pairingList){
                        angular.forEach(pairingList, function(name) {
                        	vm.pairings.push(" "+name+" ");
            			});
                    },function(error){

                    });
                }

                function setSearchParamChanges(sParams){
                    for (var i=0;i<vm.modifyFlags.length;i++){
                        if(vm.modifyFlags[i].value===sParams.isModifiedFlight){
                            sParams.isModifiedFlight = vm.modifyFlags[i];
                            break;
                        }
                    }
                    return sParams;
                }

                function searchProceed(data){
                    var viewMode = data.mode, newFromDate, newToDate;
                    newFromDate = vm.model.searchParams.fromDate;
                    if (data.flag==='new'){
                        newToDate = vm.model.searchParams.toDate;
                    }else{
                        if (viewMode == 'D'){
                            newToDate = moment(newFromDate, applicationConstants.SETTINGS.DATE_FORMAT)
                                .add(1,'d')
                                .format(applicationConstants.SETTINGS.DATE_FORMAT);
                        }
                        if (viewMode == 'W'){
                            newToDate = moment(newFromDate, applicationConstants.SETTINGS.DATE_FORMAT)
                                .add(7,'d')
                                .format(applicationConstants.SETTINGS.DATE_FORMAT);
                        }
                        if (viewMode == '2W'){
                            newToDate = moment(newFromDate, applicationConstants.SETTINGS.DATE_FORMAT)
                                .add(14,'d')
                                .format(applicationConstants.SETTINGS.DATE_FORMAT);
                        }
                        if (viewMode == 'M'){
                            newToDate = moment(newFromDate, applicationConstants.SETTINGS.DATE_FORMAT)
                                .add(31,'d')
                                .format(applicationConstants.SETTINGS.DATE_FORMAT);
                        }
                    }

                    if (validate(vm.model.searchParams)){
                        if(moment(newToDate, applicationConstants.SETTINGS.DATE_FORMAT).diff(moment(vm.model.searchParams.toDate,applicationConstants.SETTINGS.DATE_FORMAT)) >= 0){
                            vm.model.searchParams.toDate = newToDate;
                            var temp = angular.copy(vm.model.searchParams);
                            temp.airCraftType = vm.model.searchParams.airCraftType?vm.model.searchParams.airCraftType.airCraftType:'';
                            temp.airport = vm.model.searchParams.airport?vm.model.searchParams.airport.airPortCode:'';
                            temp.base = (!!vm.model.searchParams.base.hasOwnProperty('airPortCode'))?vm.model.searchParams.base.airPortCode:vm.model.searchParams.base;
                            temp.isModifiedFlight = (!!vm.model.searchParams.isModifiedFlight && !!vm.model.searchParams.isModifiedFlight.hasOwnProperty('value')) ? vm.model.searchParams.isModifiedFlight.value:vm.model.searchParams.isModifiedFlight;
                            temp.acmiType = (!!vm.model.searchParams.acmiType && !!vm.model.searchParams.acmiType.hasOwnProperty('value')) ? vm.model.searchParams.acmiType.value:vm.model.searchParams.acmiType;
                            vm.model.showSearchPanel=false;
                            var options = {
                                searchParams : temp
                            };
                            vm.onSubmitAction(options);
                        }
                    }

                }

                function validate(validateModel){
                    if(validateModel.fromDate==="" || validateModel.toDate===""){
                        MessageService.error("From Date and To Date is Required!");
                        return false;
                    }
                    return true;
                }

              vm.loadMatchingIndex =function (viewValue) {
                if(viewValue !== " ") {
                  angular.forEach(vm.airportList, function(nat) {
                    nat.matchingIndex = nat.airPortCode.toLowerCase().indexOf(viewValue.toLowerCase());
                  })
                }

              };

            },
            link: function (scope, element, attrs) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */
            }
        };
    }
}());
